/**
 * функция для отмены выделения
 */
function clearSelection() {
  if (window.getSelection) {
    if (window.getSelection().empty) { // Chrome
      window.getSelection().empty();
    } else if (window.getSelection().removeAllRanges) { // Firefox
      window.getSelection().removeAllRanges();
    }
  } else if (document.selection) { // IE?
    document.selection.empty();
  }
}

export default function copyToClipboard(textarea) {
  textarea.select();
  document.execCommand('copy');
  clearSelection();
}
